
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import SimpleMap from '../../core/components/Map/SimpleMap.vue';
import ItemActions from '../../core/components/Actions/ItemActions.vue';
import SendItemDialog from './SendItemDialog.vue';
import Vue from 'vue'
import { ItemInfo } from '../../typescript/itemInfo';
import { FeatureCollection, MultiPolygon, PolyCoords } from 'features/typescript/MapShapes';
import ModalListItems from '../components/list_items/ModalListItems.vue';
import AddPolygonsFromFile from './add_polygons_from_map/AddPolygonsFromFile.vue';
import { extractPolyCoords, normalizeToMultiPolygon } from '../../../features/core/utils/map-utils';
import { EventBus, TypeEventBus } from '../../../features/core/utils';
import { ItemServices } from '../../../features/core/api/ItemServices';
import { validationMessages } from '../../item/validationsMessages';
import AreaIndicator from '../components/AreaIndicator.vue';
@Component({
    components: {
        SimpleMap,
        SendItemDialog,
        ItemActions,
        AddPolygonsFromFile,
        ModalListItems,
        AreaIndicator
    }
})
export default class ItemMap extends Vue {
    @Prop({default: null}) itemInfo: ItemInfo
    @Prop({default: 0}) diffPolygonsArea: number;
    @Prop({default: false}) isReadOnly: boolean;
    @Prop({default: '-'}) polygonsArea: string;
    disableHandDrawing: boolean = false;
    visibleModalListItems: boolean = false;
    disabledHandDrawing: boolean = false;
    visibleModalAddPolygonsFromFile: boolean = false;
    itemPolygon: MultiPolygon | null = null;
    polygonCoords: PolyCoords = [];
    cantSubmitReason: string = '';
    coordsEditCoordinates:google.maps.Data.Feature | null = null;
    polygonReallyModified: boolean = false;
    
    

    mounted(){
        this.setBasePolygon();
        EventBus.$on(TypeEventBus.HAND_WRITING_DISABLED_BUTTON, (value) => {
            this.disabledHandDrawing = value;
        })

        EventBus.$on(TypeEventBus.SHOW_MESSAGE, (message: string, type: string) => {
            this.showSnackbar(message, type);
        })

    }

    //Seteo el poligono base que viene en el get del item
    setBasePolygon(){
        if(this.itemInfo && this.itemInfo.polygon){
            this.itemPolygon = this.itemInfo.polygon;
            let coords = extractPolyCoords(this.itemInfo.polygon)
            this.updatePolygonCoords(this.itemInfo.polygon);
            this.refreshAreaIndicator(coords);

        }
    }

    //Obtengo la referencia del SimpleMap para llamar sus metodos
    get mapItemElement(): HTMLFormElement {
        return this.$refs.itemMap as HTMLFormElement;
    }

    get sendItemDialogReference(): HTMLFormElement {
        return this.$refs.sendItemDialogRef as HTMLFormElement;
    }

    //Cuando se presiona el boton de "Dibujar Poligono"
   drawPolygon(){
    if(this.mapItemElement){
        this.mapItemElement.addNewPolygon();
    }
   }

   getPolygonFromMap(){
        return this.mapItemElement.getCoordsFromDataLayer();
   }

    //Este metodo se ejecuta luego de guardar el poligono en el Mapa
    //Se encarga de actualizar las coordenadas en SendItemDialog
   onPolygonSave(polyCoords: PolyCoords){
    this.updatePolygonCoordsInSendItemDialog(polyCoords);
    this.refreshAreaIndicator(polyCoords);
   }

   onGeometryPolygonModified(coords, reallyModified = false){
    this.polygonReallyModified = reallyModified;
    this.refreshAreaIndicator(coords);
   }

  

   setNewPolygonInMap(geojson: FeatureCollection){
    this.itemPolygon = geojson;
    this.mapItemElement.addGeoJson(geojson);
    this.updatePolygonCoords(geojson);
    this.showSnackbar('Poligono actualizado', 'success');
   }

   updatePolygonCoords(geojson: FeatureCollection){
    let newCoordinates: PolyCoords = extractPolyCoords(geojson);
    this.updatePolygonCoordsInSendItemDialog(newCoordinates);
   }

   refreshAreaIndicator(newCoordinates){
       EventBus.$emit(TypeEventBus.CALCULATING_POLYGON_AREA, true);
       ItemServices.getPolygonArea(
        {
            polygon: newCoordinates,
        }
     ).then(response => {
         this.updateAreaIndicator(response);
     }).finally(() => {
         EventBus.$emit(TypeEventBus.CALCULATING_POLYGON_AREA, false);
     })
   }

   @Emit() 
   leaveItem(){}

   get polygonHasCoordinates(){
       return this.polygonCoords.length > 0
   }

   get getSubmitTooltip(){
    if(!this.polygonHasCoordinates){
        return validationMessages.NO_POLYGON_TO_SAVE
    }

    if(this.disabledHandDrawing){
        return validationMessages.POINT_WITHOUT_SAVE
    }

    if(this.diffPolygonsArea > 20){
        return validationMessages.DIFF_AREA_BIG;
    }
   }

   updatePolygonCoordsInSendItemDialog(coordinates){
       this.polygonCoords = coordinates;
   }


    
   @Emit()
   updateAreaIndicator(response){}

   @Emit()
   showSnackbar(message: string, type: string){
       
   }
}
